import { render, staticRenderFns } from "./Leafs.vue?vue&type=template&id=77ae2a9b&"
import script from "./Leafs.vue?vue&type=script&lang=js&"
export * from "./Leafs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports